import "./TemplateDetailsDialog.scss";

import { Button, DialogProps, Flex, Segment, Text } from "@fluentui/react-northstar";
import { Question, QuestionType, TeamsQuestionnaireTemplateCategory } from "@teams/types";
import { QuestionnaireTemplateDTO } from "@teams/types/api";
import React from "react";

import { PollyDialog } from "../../../../_shared/components/PollyDialog";
import { QuestionPreview } from "../QuestionPreview";
import { TemplateCategoryComponent } from "./TemplateCard";

type TemplateDetailsDialogProps = {
  template: QuestionnaireTemplateDTO;
  onCancel: () => void;
  onConfirm: () => void;
  actionLabel: string;
} & DialogProps;

export const TemplateDetailsDialog: React.FC<TemplateDetailsDialogProps> = ({
  template,
  onCancel,
  onConfirm,
  actionLabel,
  open,
  ...dialogProps
}) => {
  return (
    <PollyDialog
      width="80vw"
      open={open}
      {...dialogProps}
      header="Template Details"
      closeOnOutsideClick
      onCancel={onCancel}
      className="template-details-dialog"
    >
      <Flex space="between">
        <div>
          <Text
            content={template.templateName}
            size="large"
            weight="bold"
            className="template-details-dialog__title"
          />
          <Text truncated content={`💬${template.questions.length}`} />
        </div>

        <Button
          data-tname="template-details-dialog-confirm-button"
          className="template-details-dialog__confirm-button"
          primary
          content={actionLabel}
          onClick={() => onConfirm()}
        />
      </Flex>

      <Flex>
        {template.categories?.map((category: TeamsQuestionnaireTemplateCategory) => (
          <TemplateCategoryComponent key={category} category={category} />
        ))}
      </Flex>

      <Flex column className="template-details-dialog__template-description">
        <Text weight="bold" content={template.templateDescription} />
        <Text className="template-details-dialog__description" content={template.description} />
      </Flex>

      <Flex gap="gap.medium" column hAlign="center" className="template-details-dialog__preview">
        {template.questions.map((question: Question<QuestionType>, index: number) => (
          <Segment key={index} color="brand" className="template-details-dialog__preview-item">
            <QuestionPreview question={question} index={index + 1} onClick={() => {}} />
          </Segment>
        ))}
      </Flex>
    </PollyDialog>
  );
};
